// extracted by mini-css-extract-plugin
module.exports = {"pulse":"Pulse_pulse__35fVt","pulse-animation":"Pulse_pulse-animation__1Kz03"};